import {FC, useRef, useState} from 'react'
import {site, settings} from '../../constants/global'
import {getRegData} from "../../wordpress/operations/get-reg-data";

interface Props {
    item: {
        name:string,
        price:number,
        sale_price: number,
        is_price_visible: boolean
    }
}

const OrderRow: FC<Props> = ({ item}) => {
    const price_string = item.price && item.is_price_visible ? item.sale_price ? (item.sale_price).toLocaleString('sv-SE') + ' kr' : (item.price).toLocaleString('sv-SE') + ' kr' : 'Pris offereras på mail efter bokning'

    return (
        <tr className="woocommerce-table__line-item order_item price-visible">
            <td className="woocommerce-table__product-name product-name">{item.name}</td>
            <td className="woocommerce-table__product-total product-total">
                <span className="woocommerce-Price-amount amount">
                    {(item.sale_price && item.is_price_visible) ? (<del>{item.price} kr</del>) : ''}
                    {price_string}
                </span>
            </td>
        </tr>
    )
};

export default OrderRow
